/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintPaletteIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABuklEQVR4nMVVzS4EQRCeg58LEeJmRQTPsRdkY6arejZpVcNN2INHQOLiiEdwcyKxEi8hIcRNxk8kXBFEOK3Usru9PzO77CS+pJJJT3V9XV9XVTvOfwIAekHzktK0B0jXoOnx2ziUNcRg0RjT8+vAxpgu0LymkF9BcyHOlOYXhbSSy+U6Wwru+/MpQD5vECzUmsbE5LueiM5c1wzFBlfKjILmu8anpc2yH/JWRDa3M9m5kYbBM5lMt9J0EiNHqJQZd7PBhEK+ipQM6VgkriMAzevWaQ9cd65f+TylkD9jSD8AZifFF5Dz1v7VquDFYMjPlp5emRj5NPqC6aTkhxgoi+DRGNNnn36pajNy3hgz4GmabpaBZCm+StNhzb8Fi4D2m5Uj/NKkT+wMbhInQL6slGelocKfEgzbz4BfbIJ3WZQmKl56NphIQKKnikTFOcMFqfPkCHjXIijXsAyx7bhGgtbsHpGGo8u0DVmU5h3PCwZjGy2+Ouio6VBrhOpREW2+P59y/oIWhl1BzGkH8eOa2ycQiARK00XEJT44SaD0ZIKmt5r230iEoAR59OVhl6bxMFhOp9MdiRIkgS/QEHXJ12aeLAAAAABJRU5ErkJggg==)
 */
export const PaintPaletteIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M19 16h-5a2 2 0 0 0-2 2v2c0 1.66-1.37 3.04-2.96 2.6A11 11 0 1 1 23 12c0 2.2-2 4-4 4ZM13.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM17.25 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-9-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-3.75 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
